

import React, { useEffect, useRef } from "react"
import {Modal,ScrollView,Select,Text,Button,Center,VStack,FormControl, HStack,Box,Checkbox, Input, IconButton,CheckIcon,DeleteIcon,} from 'native-base'
import useDialogA11y from "../hooks/useDialogA11y";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox from '@mui/material/Checkbox';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Notiflix from "notiflix";
import TableQRComponent from "./assetComponent/tableQr";
const filter = createFilterOptions();
const TableDetailsModal =({bizId,bizName,table,closeHandler,categories,onSave,downloadQR,onDelete})=>{
    const dialogRef = useRef(null);
    useDialogA11y(dialogRef, closeHandler);

    const [category,setCategory] = React.useState(table?{
        title:table.category
    }:null)
    const [tableType, setTableType] = React.useState(table?.tableType || 'standard')
    const [seatCount, setSeatCount] = React.useState(table?.seatCount || 4)
    const [wheelchairAccessible, setWheelchairAccessible] = React.useState(table?.wheelchairAccessible !== false)
    const [zone, setZone] = React.useState(table?.zone || 'inside')
    const [floor, setFloor] = React.useState(table?.floor || 'ground')
    const [elevated, setElevated] = React.useState(table?.elevated || false)

    useEffect(()=>{
         if(table){
            setCategory({
                title:table.category
            })
            setTableType(table.tableType || 'standard')
            setSeatCount(table.seatCount || 4)
            setWheelchairAccessible(table.wheelchairAccessible !== false)
            setZone(table.zone || 'inside')
            setFloor(table.floor || 'ground')
            setElevated(table.elevated || false)
         }
    },[table])

    
    if(!table){
        return null
    }
   
    return(
        <div ref={dialogRef} role="dialog" aria-modal="true" aria-label="Table Details">
            <Modal isOpen onClose={()=>{

                setCategory(null)
                closeHandler()
            }} size={'xl'}>
          <Modal.Content >
            <Modal.CloseButton accessibilityLabel="Close" />
            <Modal.Header>
              <HStack alignItems={'center'}>
                <Text fontSize={'lg'}>
                Table Details
              </Text>
              {onDelete && (
                <IconButton onPress={()=>{
                                onDelete(table)
                              }}>
                  <DeleteIcon/>
                  </IconButton>
              )}
              
              </HStack>
            
            </Modal.Header>
            <Modal.Body>
            <HStack alignItems={'center'}>
            
              <Text fontSize={'md'}>
                 Table Location :
              </Text>
              <Autocomplete
                size={'small'}
                value={category}
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        setCategory({
                        title: newValue,
                    });
                    } else if (newValue && newValue.inputValue) {
                    // Create a new value from the user input
                    setCategory({
                        title: newValue.inputValue,
                    });
                    } else {
                        setCategory(newValue);
                    }
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);

                    const { inputValue } = params;
                    // Suggest the creation of a new value
                    const isExisting = options.some((option) => inputValue === option.title);
                    if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        title: `Add "${inputValue}"`,
                    });
                    }

                    return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={categories.map(c=>{
                    return{
                        title:c
                    }
                })}
                getOptionLabel={(option) => {
                    // Value selected with enter, right from the input
                    if (typeof option === 'string') {
                    return option;
                    }
                    // Add "xxx" option created dynamically
                    if (option.inputValue) {
                    return option.inputValue;
                    }
                    // Regular option
                    return option.title;
                }}
                renderOption={(props, option) => <li {...props}>{option.title}</li>}
                sx={{ width: 300,margin:2 }}
                freeSolo

                renderInput={(params) => (
                    <TextField {...params} label="Enter Location or category" />
                )}

    />

              </HStack>
              <HStack alignItems={'center'}>
                <Text fontSize={'md'}>
                Table Number :
                </Text>
                <Text fontSize={'md'}>
                {table['tableNo']}
                </Text>
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <Text fontSize={'md'}>Table Type :</Text>
                <TextField
                  size="small"
                  select
                  value={tableType}
                  onChange={(e) => setTableType(e.target.value)}
                  sx={{ width: 200, margin: 2 }}
                  label="Table Type"
                >
                  <MenuItem value="standard">Standard</MenuItem>
                  <MenuItem value="booth">Booth</MenuItem>
                  <MenuItem value="bar-stool">Bar Stool</MenuItem>
                  <MenuItem value="high-top">High-Top</MenuItem>
                  <MenuItem value="high-table">High-Table</MenuItem>
                  <MenuItem value="counter">Counter</MenuItem>
                </TextField>
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <Text fontSize={'md'}>Seats :</Text>
                <TextField
                  size="small"
                  type="number"
                  value={seatCount}
                  onChange={(e) => setSeatCount(e.target.value)}
                  sx={{ width: 100, margin: 2 }}
                  label="Seat Count"
                  inputProps={{ min: 1, max: 20 }}
                />
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <Text fontSize={'md'}>Zone :</Text>
                <TextField
                  size="small"
                  select
                  value={zone}
                  onChange={(e) => setZone(e.target.value)}
                  sx={{ width: 150, margin: 2 }}
                  label="Zone"
                >
                  <MenuItem value="inside">Inside</MenuItem>
                  <MenuItem value="outside">Outside</MenuItem>
                </TextField>
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <Text fontSize={'md'}>Floor :</Text>
                <TextField
                  size="small"
                  select
                  value={floor}
                  onChange={(e) => setFloor(e.target.value)}
                  sx={{ width: 200, margin: 2 }}
                  label="Floor"
                >
                  <MenuItem value="ground">Ground Floor</MenuItem>
                  <MenuItem value="outside">Outside</MenuItem>
                  <MenuItem value="upstairs">Upstairs</MenuItem>
                  <MenuItem value="downstairs">Downstairs</MenuItem>
                </TextField>
              </HStack>

              <HStack alignItems={'center'} mt={2}>
                <FormControlLabel
                  control={<MuiCheckbox checked={wheelchairAccessible} onChange={(e) => setWheelchairAccessible(e.target.checked)} />}
                  label="Wheelchair Accessible"
                />
              </HStack>

              <HStack alignItems={'center'} mt={1}>
                <FormControlLabel
                  control={<MuiCheckbox checked={elevated} onChange={(e) => setElevated(e.target.checked)} />}
                  label="Raised Section (elevated platform)"
                />
              </HStack>

              {onSave && (
                <Button marginTop={3} onPress={()=>{
                if(category && (category.title??[]).length>1){
                  onSave({
                      ...table,
                      category: category.title,
                      tableType,
                      seatCount: parseInt(seatCount) || 4,
                      wheelchairAccessible,
                      zone,
                      floor,
                      elevated,
                    })
                }

                }}>
                  Save
                </Button>
              )}
              <Button marginTop={3} onPress={()=>{

                 downloadQR(table)
              }}>
                Download Qr
              </Button>
              
              
            
            </Modal.Body>
            </Modal.Content>
            </Modal>
            <TableQRComponent bizName={bizName} bizId={bizId} tableNo={table['tableNo']}/>
        </div>
    )
}

export default TableDetailsModal